module.exports = "input.ng-touched.ng-invalid{\n border-color: red;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/view/auth/signin/signin.component.css
// module id = ./src/app/view/auth/signin/signin.component.css
// module chunks = main